module.exports = __webpack_public_path__ + "img/505Vector.b34cd89a.png";